


































import { Component, Vue, Prop } from "vue-property-decorator";
import requestService from "@/service/requestService";
import loadingService from "@/service/loadingService";
import { MESSAGE } from "@/model/Message";
import { Action, Getter } from "vuex-class";

@Component({
  components: {
  }
})
export default class sknMenuDialog extends Vue {

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("seibiMenuCd", { namespace: "InspectionDetail" })
  seibiMenuCd: any;
  @Action("setSeibiMenuCd", { namespace: "InspectionDetail" })
  setSeibiMenuCd: any;

  reqService: requestService;
  loadingService: loadingService = new loadingService();
  showDialog: boolean = false;
  errorMessage: string = "";

  shakenShurui: any = [];

  $refs!: {
  };

  created() {
    this.reqService = new requestService();
    this.getShakenShurui();
  }

  getShakenShurui() {
    this.reqService.getSeibiMenuList().then(
      (res: any) => {
        let shakenShuruiSeibiMenuCd = this.seibiMenuCd;
        let isSaved = shakenShuruiSeibiMenuCd != "";
        res.map((data: any) => {
          if (isSaved && shakenShuruiSeibiMenuCd == data.seibiMenuCd) {
            data.selected = "1";
          } else {
            data.selected = "0";
          }
        });
        this.$set(this, "shakenShurui", res);
      },
      (err: any) => {
        this.$set(this, "shakenShurui", []);
      }
    );
  }

  selShakenShurui(code: string) {
    this.shakenShurui.map((data: any) => {
      if (data.seibiMenuCd == code) {
        if (data.selected == "1") {
          /** 2022-12-19 sh #8140(BQR986-2) ommit. [START] */
          /** 未選択の状態にすることはないので、0に戻せないようにする */
          // data.selected = "0";
          /** 2022-12-19 sh #8140(BQR986-2) ommit. [END] */
        } else {
          data.selected = "1";
        }
      } else {
        data.selected = "0";
      }
    });
  }

  onOpen() {
    this.showDialog = true;
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    this.$nextTick(()=>{
      this.selShakenShurui(this.seibiMenuCd);
    });
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
    this.errorMessage = "";
  }

  onClose() {
    this.setLoading(false);
    this.showDialog = false;
  }

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  setLoading(b: any) {
    if (b) {
      this.loadingService.show();
    } else {
      this.loadingService.hide();
    }
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  onConfirm() {
    let saveFlg = false;
    let seibiMenuCd = '';
    this.shakenShurui.forEach((element: any) => {
      if (element.seibiMenuCd != this.seibiMenuCd && element.selected == "1") {
        seibiMenuCd = element.seibiMenuCd;
        saveFlg = true;
      }
    });
    if (saveFlg) this.$emit('onConfirm', seibiMenuCd);
  }
}
